import { NationalOutlookScreen } from './nationalOutlookScreen';

const props = [
];

export const NationalOutlookScreenDirective = reactDirective => reactDirective(NationalOutlookScreen, props);
NationalOutlookScreenDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('nationalOutlookScreen', NationalOutlookScreenDirective);
